import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { fetchCardLabels, fetchLabels } from '../../redux/Slices/labelSlice';
import './scss/CardLabels.scss';
import { getTextColor, rgbaColor } from '../../utils/helpers';
import useHandlePopoverClick from '../../hooks/useHandlePopoverClick';

const CardLabels = ({ cardId, isReadOnly }) => {
    const dispatch = useDispatch();
    const { labelsByCard } = useSelector((state) => state.labels);
    const { card } = useSelector((state) => state.card);
    const labels = labelsByCard[cardId] || [];
    const { handlePopoverClick } = useHandlePopoverClick();

    useEffect(() => {
        if (cardId && labels.length === 0) {
            dispatch(fetchCardLabels(cardId));
        }
    }, [cardId, labels.length, dispatch]);

    return (
        <>
            {labels.length > 0 && (
                <div className="zoobbe-labels">
                    <h5>Labels</h5>
                    <div className='label-list-container'>
                        <div className='label-list'>
                            {labels.map(label => (
                                <span
                                    key={label._id}
                                    style={{ color: label.color, backgroundColor: rgbaColor(label.color, 0.1), opacity: 1, fontWeight: 500 }}
                                    // style={{ backgroundColor: label.color, color: getTextColor(label.color) }}
                                    className="zoobbe-label zoobbe-bug-fix"
                                    id={`popover-card-label-${label._id}`}
                                    onClick={(e) => !isReadOnly && handlePopoverClick(e, 'addLabels', { cardId, card })}
                                    data-popover-trigger
                                >
                                    {label.text}
                                </span>
                            ))}
                            {
                                !isReadOnly && (

                                    <div
                                        className="add-labels-to-card"
                                        id='popover-add-labels-to-card'
                                        onClick={(e) => handlePopoverClick(e, 'addLabels', { cardId, card })}
                                        data-popover-trigger
                                    >
                                        <span className="material-symbols-outlined">add</span>
                                    </div>
                                )
                            }

                        </div>

                    </div>
                </div>
            )}
        </>
    );
};

export default CardLabels;
